import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { CatalogTundishShroud } from "../models/CatalogTundishShroud";

export const getCatalogTundishShrouds = async () => {
  const apiService = new MESApiService();

  const parameters: spParameter[] = [{ name: "IncludeInactives", value: true }];

  return await apiService.callV2("[CAS].[GetTundishShrouds]", parameters);
};
export const upsertCatalogTundishShroud = async (
  Tundish: CatalogTundishShroud,
) => {
  const apiService = new MESApiService();

  const parameters: spParameter[] = [
    { name: "TundishShroudId", value: Tundish.TundishShroudId },
    { name: "TundishShroudName", value: Tundish.TundishShroudName },
    { name: "Enabled", value: Tundish.Enabled },
  ];

  return await apiService.callV2("[CAS].[UpsertTundishShroud]", parameters);
};

export const deleteCatalogTundishShroud = async (
  TundishShroudId: number | null,
) => {
  const apiService = new MESApiService();

  const parameters: spParameter[] = [
    { name: "TundishShroudId", value: TundishShroudId },
  ];

  return await apiService.callV2("[CAS].[DeleteTundishShroud]", parameters);
};
